import { LuLayoutDashboard } from 'react-icons/lu'
import { PiMedalFill } from 'react-icons/pi'
import { FaList, FaStore, FaTags, FaUserCog, FaUsers, FaUsersCog, FaUserSecret } from 'react-icons/fa'
import { BiSolidCategory } from 'react-icons/bi'
import { GrTransaction, GrUserManager } from 'react-icons/gr'
import { FaBuildingUser, FaBoxOpen } from 'react-icons/fa6'
import { MdOutlinePlaylistAdd } from 'react-icons/md'
import { ImBoxAdd } from 'react-icons/im'
import { BsBank, BsCart4, BsCartDashFill } from 'react-icons/bs'
import { IoAnalytics } from 'react-icons/io5'

const appRoutes = [
    {
        text: 'Menu',
        child: [
            {
                url: '/admin',
                text: 'Dashboard',
                icon: <LuLayoutDashboard />,
            },
            {
                active: ['/admin/admins'],
                url: '/admin/admins',
                text: 'Admins',
                icon: <FaUserSecret />,
            },
            {
                active: ['/admin/roles'],
                url: '/admin/roles',
                text: 'Roles',
                icon: <FaUserCog />,
            },
            {
                active: ['/admin/users'],
                url: '/admin/users',
                text: 'Users',
                icon: <FaUsersCog />,
            },
            {
                active: ['/admin/stores'],
                url: '/admin/stores',
                text: 'Stores',
                icon: <FaStore />,
            },
            {
                active: ['/admin/store-users'],
                url: '/admin/store-users',
                text: 'Store Users',
                icon: <FaBuildingUser />,
            },
            {
                active: ['/admin/bank-accounts'],
                url: '/admin/bank-accounts',
                text: 'Bank Accounts',
                icon: <BsBank />,
            },
            {
                active: ['/admin/bank-transactions'],
                url: '/admin/bank-transactions',
                text: 'Bank Transactions',
                icon: <GrTransaction />,
            },
            {
                active: ['/admin/wallet-transactions'],
                url: '/admin/wallet-transactions',
                text: 'Wallet Transactions',
                icon: <GrTransaction />,
            },
            {
                active: ['/admin/customers'],
                url: '/admin/customers',
                text: 'Customers',
                icon: <FaUsers />,
            },
            {
                active: ['/admin/vendors'],
                url: '/admin/vendors',
                text: 'Vendors',
                icon: <GrUserManager />,
            },
            {
                active: ['/admin/referrals'],
                url: '/admin/referrals',
                text: 'Referrals',
                icon: <GrUserManager />,
            },
            {
                active: ['/admin/brands', '/admin/categories', '/admin/attributes', '/admin/expenses'],
                text: 'Masters',
                icon: <MdOutlinePlaylistAdd />,
                child: [
                    {
                        active: ['/admin/brands'],
                        url: '/admin/brands',
                        text: 'Brands',
                        icon: <PiMedalFill />,
                    },
                    {
                        active: ['/admin/categories'],
                        url: '/admin/categories',
                        text: 'Categories',
                        icon: <BiSolidCategory />,
                    },
                    {
                        active: ['/admin/attributes'],
                        url: '/admin/attributes',
                        text: 'Attributes',
                        icon: <FaTags />,
                    },
                    {
                        active: ['/admin/expenses'],
                        url: '/admin/expenses',
                        text: 'Expenses',
                        icon: <PiMedalFill />,
                    },
                ],
            },
            {
                active: ['/admin/products'],
                url: '/admin/products',
                text: 'Products',
                icon: <FaBoxOpen />,
            },
            {
                active: ['/admin/purchases'],
                url: '/admin/purchases',
                text: 'Purchases',
                icon: <ImBoxAdd />,
            },
            {
                active: ['/admin/store-orders'],
                url: '/admin/store-orders',
                text: 'Store Orders',
                icon: <BsCart4 />,
            },
            {
                active: ['/admin/orders'],
                url: '/admin/orders',
                text: 'Customer Orders',
                icon: <BsCart4 />,
            },
            {
                active: ['/admin/analysis'],
                text: 'Analysis',
                icon: <IoAnalytics />,
                child: [
                    {
                        active: ['/admin/analysis/purchases'],
                        url: '/admin/analysis/purchases',
                        text: 'Purchases',
                        icon: <ImBoxAdd />,
                    },
                    {
                        active: ['/admin/analysis/store-orders'],
                        url: '/admin/analysis/store-orders',
                        text: 'Store Orders',
                        icon: <BsCart4 />,
                    },
                    {
                        active: ['/admin/analysis/orders'],
                        url: '/admin/analysis/orders',
                        text: 'Customer Orders',
                        icon: <BsCart4 />,
                    },
                    {
                        active: ['/admin/analysis/returns'],
                        url: '/admin/analysis/returns',
                        text: 'Return Products',
                        icon: <BsCartDashFill />,
                    },
                ],
            },
            {
                active: ['/admin/login-history'],
                url: '/admin/login-history',
                text: 'Login History',
                icon: <FaList />,
            },
        ],
    },
]

export default appRoutes
